import { render, staticRenderFns } from "./goodsPurchaseDetail.vue?vue&type=template&id=3c790512&scoped=true"
import script from "./goodsPurchaseDetail.vue?vue&type=script&lang=js"
export * from "./goodsPurchaseDetail.vue?vue&type=script&lang=js"
import style0 from "./goodsPurchaseDetail.vue?vue&type=style&index=0&id=3c790512&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c790512",
  null
  
)

export default component.exports